import React from 'react';
import { setWebsiteUrl } from '../../utils/Utils';

const styleFacebook = {
    width: '45px'
}

export default function ExternalLinks(props) {
    return (
        <div className="external-links">
            {props.data.website && 
                <a target="_blank" href={setWebsiteUrl(props.data.website)}>
                    <img src="/images/browser.png" alt="Logotipo Website"></img>
                </a>
            }
            {props.data.facebook && 
                <a target="_blank" href={setWebsiteUrl(props.data.facebook)}>
                    <img style={styleFacebook} src="/images/facebook_black.png" alt="Logotipo Facebook"></img>
                </a>
            }
            {props.data.instagram && 
                <a target="_blank" href={setWebsiteUrl(props.data.instagram)}>
                    <img style={styleFacebook} src="/images/instagram_black.png" alt="Logotipo Instagram"></img>
                </a>
            }
        </div>
    )
}
